import regexMap from '../constants/regex-map';
import latinCharacters from '../constants/latin-characters';

/**
 * Para limpiar el nombre de coporate
 * @param nameCompany
 * @return {Element HTML}
 */
function clearNameCompanyCorporate(nameCompany) {
  let clearNameCompany = '';
  if (nameCompany !== null) {
    if (regexMap.NON_ALPHA_LATIN_CHARACTERS.test(nameCompany)) {
      clearNameCompany = clearNameCompany.replace(regexMap.NON_ALPHA_LATIN_CHARACTERS, (match) => {
        return latinCharacters[match];
      });
    }
    clearNameCompany = nameCompany.replace(regexMap.CLEAR_MIDDLE_SLASH, ' ').toLowerCase();
  }
  return clearNameCompany;
}

/**
 * Para devolver un arreglo de booleanos
 *
 * @return {Array boolean}
 */
function seatsAvailableCorpoHp(seatmapCollectionModel, isCorporateFlow = false) {
  const seatsAvailable = [];
  if ( seatmapCollectionModel ) {
    Object.keys(seatmapCollectionModel._seatmapsBySegment).forEach(indexSegment => {
      const seatmapSelected = seatmapCollectionModel._seatmapsBySegment[indexSegment];
      const isAvailable = seatmapSelected.isAvailable;
      const isCorporateSeatMap = seatmapSelected.isCorporateSeatMap;
      const isAvailableCorporate = isCorporateFlow && !isAvailable && isCorporateSeatMap;
      seatsAvailable.push(!isAvailableCorporate);
    });
  }
  return seatsAvailable;
}

/**
 * Para validar si contiene empresas
 *
 * @return {boolean}
 */
function validateCompaniesCorpo(companies) {
  return companies && Array.isArray(companies.companies) && companies.length === 0;
}

export {
  clearNameCompanyCorporate,
  seatsAvailableCorpoHp,
  validateCompaniesCorpo,
};